import React from 'react'
import Head from '../components/Head'
import Header from '../components/Header'
import Intro from '../components/IntroPress'
import InquiryCard from '../good_components/InquiryCard'
import Footer from '../components/footer'
import Button from '../components/Button'

const all_representatives = require('../data/representatives.json')
const all_press = require('../data/press.json')

export default class extends React.Component {
  constructor(props) {
    super(props)

    this.loadMore = this.loadMore.bind(this)

    this.state = {
      index: 6,
      showButton: true
    }
  }

  loadMore() {
    if (this.state.index + 6 >= all_press.length) {
      this.setState({ index: this.state.index + 6, showButton: false })
    } else {
      this.setState({ index: this.state.index + 6 })
    }
  }

  render() {
    const representative = all_representatives.find(r => r.header == 'Media Inquiries')
    const press = all_press.slice(0, this.state.index)
    return (
      <React.Fragment>
        <Head
          title="PlayVS | Press"
          description="PlayVS is the official high school esports league, sanctioned by the NFHS. Play with your friends, compete for your school, and win the state championship."
          keywords="high school esports"
        />

        <Header />

        <Intro />

        <section className="section">
          <div className="container">
            <div className="section__head">
              <h2>Some Kind Words</h2>
              <p>
                Interested in learning more about who we are? Check out some of our recent press.
              </p>
            </div>
            <div className="section__body">
              <div className="row">
                {press.map(article => {
                  return (
                    <div className="column--third">
                      <div className={`card contained ${article.publisher}`}>
                        <div className="imageContainer">
                          <img src={article.logo} />
                        </div>
                        <div className="meta minHeight">
                          <div className="h7">{article.title}</div>
                          <p>{article.description}</p>
                        </div>
                        <a className="coverLink" href={article.link} target="_blank" />
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="section__CTA" style={{ marginTop: 0 }}>
              {this.state.showButton && (
                <Button type="button" className="btn btn__default" text="More" onClick={this.loadMore} />
              )}
            </div>
          </div>
        </section>

        <div className="row" style={{ marginBottom: '7.5rem' }}>
          <InquiryCard
            header={representative.header}
            name={representative.name}
            photo={representative.photo}
            title={representative.title}
            email={representative.email}
          />
        </div>

        <Footer />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/pages/press.js